/* Desktop FAQ state is isolated from the existing mobile presentation. */
(() => {
  const desktop = matchMedia('(min-width:750px)');
  const saved = new Map();
  const offerCopy = new Map();
  // The existing desktop artwork has its own commercial copy. Reuse it
  // verbatim rather than exposing the different mobile product-price label.
  const syncOffer = () => {
    for (const [target, source] of [['.lp-kit-shipping','.fxd-595'],['.lp-kit-preco','.fxd-598']]) {
      const element = document.querySelector(target);
      const original = document.querySelector('.lp-exact-canvas ' + source);
      if (!element || !original) continue;
      if (desktop.matches && !offerCopy.has(element)) {
        offerCopy.set(element, element.textContent);
        element.textContent = original.textContent.replace(/\s+/g, ' ').trim();
      } else if (!desktop.matches && offerCopy.has(element)) {
        element.textContent = offerCopy.get(element);
        offerCopy.delete(element);
      }
    }
  };
  const sync = () => {syncOffer();document.querySelectorAll('.lp-faq-item').forEach(item => {
    const button = item.querySelector('.lp-faq-pergunta');
    const answer = item.querySelector('.lp-faq-resposta');
    if (!button || !answer) return;
    if (desktop.matches && !saved.has(item)) {
      saved.set(item, {expanded: button.getAttribute('aria-expanded'), hidden: answer.hidden});
      button.setAttribute('aria-expanded', 'false');
      answer.hidden = true;
    } else if (!desktop.matches && saved.has(item)) {
      const previous = saved.get(item);
      button.setAttribute('aria-expanded', previous.expanded);
      answer.hidden = previous.hidden;
      saved.delete(item);
    }
  });};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  desktop.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();
